import React from 'react';
import SignupForm from '../components/auth/SignupForm';

const SignupPage = () => {
  return <SignupForm />;
};

export default SignupPage;